import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, X, Send } from "lucide-react";

export default function LiveChat() {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);

  const handleSend = async (e) => {
    e.preventDefault();
    if (!name.trim() || !message.trim()) return;
    setSending(true);
    try {
      await fetch("/api/chat", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, message }),
      });
      setSent(true);
      setName("");
      setMessage("");
      setTimeout(() => setSent(false), 3000);
    } catch {
      // silent fail
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="fixed bottom-6 right-4 sm:right-20 z-[9999]" data-testid="live-chat-widget">
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 20, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.95 }}
            transition={{ duration: 0.2 }}
            className="absolute bottom-16 right-0 w-80 border border-white/10 bg-[#121212] shadow-2xl"
          >
            <div className="bg-[#FF3366] p-4 flex items-center justify-between">
              <div>
                <p className="font-heading font-bold text-sm text-white">Chat con NINFA</p>
                <p className="text-white/70 text-xs font-mono">Rispondiamo entro 24h</p>
              </div>
              <button onClick={() => setOpen(false)} className="text-white/70 hover:text-white">
                <X size={18} />
              </button>
            </div>
            <div className="p-4">
              {sent ? (
                <div data-testid="chat-success" className="text-center py-6">
                  <p className="text-green-400 font-mono text-sm">Messaggio inviato!</p>
                  <p className="text-[#A3A3A3] text-xs mt-2">Ti risponderemo al piu presto.</p>
                </div>
              ) : (
                <form onSubmit={handleSend} className="space-y-3">
                  <input
                    data-testid="chat-name-input"
                    type="text"
                    placeholder="Il tuo nome"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className="w-full bg-transparent border-b border-white/20 py-2 text-white text-sm placeholder-white/30 focus:outline-none focus:border-[#FF3366] font-mono"
                    required
                  />
                  <textarea
                    data-testid="chat-message-input"
                    placeholder="Scrivi un messaggio..."
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    rows={3}
                    className="w-full bg-transparent border-b border-white/20 py-2 text-white text-sm placeholder-white/30 focus:outline-none focus:border-[#FF3366] font-mono resize-none"
                    required
                  />
                  <button
                    data-testid="chat-send-btn"
                    type="submit"
                    disabled={sending}
                    className="w-full bg-[#FF3366] text-white font-bold uppercase tracking-widest px-4 py-3 text-xs hover:bg-white hover:text-black transition-colors flex items-center justify-center gap-2 disabled:opacity-50"
                  >
                    <Send size={14} /> {sending ? "INVIO..." : "INVIA"}
                  </button>
                </form>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <button
        data-testid="live-chat-toggle"
        onClick={() => setOpen(!open)}
        className={`w-14 h-14 flex items-center justify-center transition-all duration-300 shadow-lg ${
          open ? "bg-white text-black rotate-0" : "bg-[#FF3366] text-white animate-pulse-glow"
        }`}
      >
        {open ? <X size={24} /> : <MessageCircle size={24} />}
      </button>
    </div>
  );
}
